/**
 * Shared constants for workout components
 */
export const EQUIPMENT_LABELS = {
  aucun: { fr: 'Poids du corps', en: 'Bodyweight' },
  halteres: { fr: 'Haltères', en: 'Dumbbells' },
  barre: { fr: 'Barre', en: 'Barbell' },
  barbell: { fr: 'Barre', en: 'Barbell' },
  banc_barre: { fr: 'Banc + Barre', en: 'Bench + Bar' },
  banc_halteres: { fr: 'Banc + Haltères', en: 'Bench + DB' },
  machine: { fr: 'Machine', en: 'Machine' },
  cables: { fr: 'Câbles', en: 'Cables' },
  barre_traction: { fr: 'Barre de traction', en: 'Pull-up Bar' },
  bodyweight: { fr: 'Poids du corps', en: 'Bodyweight' },
};

export const MUSCLE_COLORS = {
  'pectoraux': 'from-red-600/40 to-red-900/40',
  'poitrine': 'from-red-600/40 to-red-900/40',
  'dos': 'from-blue-600/40 to-blue-900/40',
  'quadriceps': 'from-emerald-600/40 to-emerald-900/40',
  'fessiers': 'from-pink-600/40 to-pink-900/40',
  'ischio-jambiers': 'from-teal-600/40 to-teal-900/40',
  'épaules': 'from-orange-600/40 to-orange-900/40',
  'biceps': 'from-violet-600/40 to-violet-900/40',
  'triceps': 'from-indigo-600/40 to-indigo-900/40',
  'abdominaux': 'from-amber-600/40 to-amber-900/40',
  'lombaires': 'from-yellow-600/40 to-yellow-900/40',
  'cardio': 'from-rose-600/40 to-rose-900/40',
  'mobilité': 'from-cyan-600/40 to-cyan-900/40',
  'trapèzes': 'from-lime-600/40 to-lime-900/40',
};

export const DIFFICULTY_CONFIG = {
  beginner: { label_fr: 'Débutant', label_en: 'Beginner', color: 'text-green-400 bg-green-400/10 border-green-400/30' },
  intermediate: { label_fr: 'Intermédiaire', label_en: 'Intermediate', color: 'text-amber-400 bg-amber-400/10 border-amber-400/30' },
  advanced: { label_fr: 'Avancé', label_en: 'Advanced', color: 'text-red-400 bg-red-400/10 border-red-400/30' },
};
